import categoryList from "./categoryList"

const findCategory = category =>
  categoryList.filter(item => item.name === category && item.background)

const getBackground = category => {
  const result = findCategory(category)
  return result.length === 1 ? result[0].background : "#eee"
}

export default getBackground
